export default __webpack_public_path__ + "static/median-duration-dark-mode-29f79b8b2aaff9cf4be1d38c5d850754.png";